import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  card: {
    // padding: '10px 0',
    // boxSizing: 'border-box',
    // width: 360,
    height: '100%',
    // boxShadow: '2px 2px 6px 0 rgba(0, 0, 0, 0.2)',
    // backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    // borderRadius: 10,
    // position: 'absolute',
    // right: '0',
    zIndex: 10,
    // top: 0,
    backgroundSize: 'cover',
    // backgroundImage: 'url(/static/media/wpback.a2e62ace.jpg)',

    '@media (max-width:500px)': {
      width: '100%',
    },
  },
  inputContainer: {
    // position: 'absolute',
    width: '-webkit-fill-available',
    bottom: '10px',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 10,
    height: 40,
    background: '#fff',
    padding: '12px 15px 0px',
    borderTop: '1px solid #E1E4EA',
    // '& > div:first-child': {
    //   width: '60% !important',
    //   backgroundColor: '#0074f8 !important',
    // },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    paddingRight: '15px',
    // marginBottom: 10,
    height: '65%',
  },
  bigContent: {
    height: '100% !important',
    // marginBottom: '8px',
    padding: '0 15px 8px',
    backgroundColor: 'rgb(255 255 255 / 60%)',
  },
  loading: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  dateSeparator: {
    backgroundColor: '#fff',
    color: '#2B303B',
    padding: '4px 16px',
    borderRadius: '9999px',
    fontSize: '10px',
    fontWeight: '500',
    border: '1px solid #E1E4EA',
    // boxShadow: '0px 1px 0.5px 0px #0b141a42',
  },
  chatLockMsg: {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    background: '#FFFAEB',
    bottom: 75,
    left: 14,
    width: '86%',
    borderRadius: 8,
    border: '1px solid #F6B51E',
    padding: '10px',
    fontFamily: 'Averta Light',
    boxShadow: '0px 10px 32px -4px #18274B1A',
  },
  chatLockMsgTitle: {
    fontFamily: 'Averta Bold',
    fontSize: 14,
    fontWeight: 'bold',
    paddingBottom: 10,
  },
  chatLockMsgBody: {
    color: '#999999',
    fontFamily: 'Averta',
    fontSize: 14,
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginTop: 10,
  },
  line: {
    flexGrow: 1,
    height: '1px',
    backgroundColor: '#D1D5DB',
  },
}));

export default useStyles;
